import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { ArrowRightIcon } from '@udacity/chakra-uds-icons';

import { ButtonLink } from '~/components/button-link';
import { Glyph } from '~/components/glyph';
import { trackEvent } from '~/features/analytics/track-event';

export function ForBusinessCard() {
  return (
    <Flex
      aria-labelledby='business-card'
      as='aside'
      bg='accent.sky.100'
      border='1px solid'
      borderColor='accent.sky.500'
      borderRadius='md'
      gap='16px'
      padding='24px'
      width='100%'
      alignItems={{
        lg: 'center',
      }}
      flexDir={{
        base: 'column',
        lg: 'row',
      }}
    >
      <Flex
        flex='1'
        flexDir={{
          base: 'column',
          lg: 'row',
        }}
        gap={{
          base: '8px',
          lg: '16px',
        }}
      >
        <Glyph height={40} name='suitcase-three' width={40} />
        <Box>
          <Heading as='h2' mb='0px' size='marketing-xl'>
            Udacity for Business
          </Heading>
          <Text fontSize='sm' id='business-card'>
            Buying for a business? Check out our business plans.
          </Text>
        </Box>
      </Flex>
      <ButtonLink
        buttonProps={{
          variant: 'outline',
          width: {
            base: '100%',
            md: 'fit-content',
          },
          size: 'icon-right',
          rightIcon: <ArrowRightIcon height='24px' width='24px' />,
          onClick: () =>
            trackEvent({
              type: 'click',
              name: 'Product Page CTA Clicked',
              label: 'udacity_for_business_learn_more_clicked',
            }),
        }}
        linkProps={{
          href: '/enterprise/overview',
        }}
      >
        Learn More
      </ButtonLink>
    </Flex>
  );
}
